import type { FC } from 'react'

import { Input } from 'antd'
import type { TextAreaProps } from 'antd/lib/input'
import cn from 'classnames'

import styles from '@web/shared/components/app-text-area/ui/app-text-area.module.css'

type TProps = { className?: string; minRows?: number } & TextAreaProps

export const AppTextArea: FC<TProps> = ({
  className,
  minRows,
  autoSize,
  ...props
}) => (
  <Input.TextArea
    {...props}
    className={cn(className, styles.textArea)}
    autoSize={autoSize ?? { minRows: minRows ?? 7, maxRows: 20 }}
  />
)
